const map = {
	"./Casing Pipe.png": 7540,
	"./HDPE Pipe.png": 3888,
	"./Plumbing & Casing Pipe.png": 182,
	"./RS Pipe.png": 1460,
	"./SWR Pipe.png": 7035,
	"./Solvent Cement.jpeg": 4319,
	"./range.jpeg": 1125,
	"./uPVC Column Pipe.jpeg": 8372,
	"./uPVC Pipe.png": 5621
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9351;